<style lang="scss">
@import './behavior-item.scss';
</style>
<template>
<div class="behavior">
  <!-- 活跃，事件触达，页面访问更改结构 -->
  <!--行为名称及操作 -->
  <div v-if="!judgeKeyName" class="behavior-header">
    <strong class="behavior-header-name">{{ itemName }}</strong>
    <i class="behavior-header-delete iconfont icon-removed" @click="removeItem"></i>
  </div>
  <div class="behavior-item">
    <!--行为名称 -->
    <strong
      v-if="judgeKeyName"
      class="behavior-item-name">{{ itemName }}</strong>
    <!--行为内容 -->
    <div class="behavior-item-content">
      <slot name="itemContent"></slot>
      <div v-if="dateMove" class="behavior-item-content-slot">
        <div class="behavior-item-ivu-date">
          <Date-picker
            v-show="dateMove"
            :value="dateValue"
            format="yyyy/MM/dd"
            type="daterange"
            placement="bottom-start"
            placeholder="选择日期"
            @on-change="dateChange"
            split-panels></Date-picker>
        </div>
        <i-select
          v-if="Object.keys(selectInfo.value).length > 1"
          v-model="selectValue"
          @on-change="setcontentValue"
          class="behavior-item-ivu-value">
          <Option
            v-for="(item, key) in selectInfo.value"
            :label="item"
            :value="key"
            :key="key">{{ item }}</Option>
        </i-select>
        <strong v-else class="behavior-item-content-slot-select-text">{{ selectInfo.value[selectValue] }}</strong>
        <i-select v-model="selectSymbol" @on-change="setcontentValue" class="behavior-item-ivu-symbol">
          <Option
            v-for="(item, key) in selectInfo.symbol"
            :label="item"
            :value="key"
            :key="key">{{ item }}</Option>
        </i-select>
        <!-- $between 介于时选择数值范围 -->
        <div v-if="selectSymbol === '$between'" class="behavior-item-ivu-num">
          <Input-number
            class-name="behavior-item-ivu-num"
            :max="selectRange[1]"
            :min="1"
            v-model="selectRange[0]"
            @on-change="setcontentValue"></Input-number>
          <span style="padding: 0 5px;">~</span>
          <Input-number
            class-name="behavior-item-ivu-num"
            :min="selectRange[0] + 1"
            v-model="selectRange[1]"
            @on-change="setcontentValue"></Input-number>
        </div>
        <!-- 选择单独数值 -->
        <Input-number
          v-else
          class-name="behavior-item-ivu-num"
          :max="1000"
          :min="1"
          v-model="selectNumber"
          @on-change="setcontentValue"></Input-number>
        <strong class="behavior-item-content-slot-unit">{{ selectInfo.unit }}</strong>
      </div>
      <!-- 流失情况展示 -->
      <div v-if="itemKeyName === 'lostDays'">
        <span>{{ $t('userBehavior.lostDays.info.a') }}</span>
        <!-- 选择单独数值 -->
        <i-select
          v-model="selectNumber"
          @on-change="setcontentValue"
          class="behavior-item-ivu-num">
          <Option
            v-for="(item, key) in selectInfo.number"
            :label="item"
            :value="key"
            :key="key">{{ item }}</Option>
        </i-select>
        <span>{{ $t('userBehavior.lostDays.info.b') }}</span>
      </div>
    </div>
    <!--行为操作按钮 -->
    <i
      v-if="judgeKeyName"
      class="behavior-item-delete iconfont icon-removed"
      @click="removeItem"></i>
  </div>
</div>
</template>
<script>
  import baseInfo from '../../libs/usergroup-item-base';
  import bus from '../../libs/bus';

  const baseInfoTemp = baseInfo.changeBehaviorLang();
  export default {
    name: 'moduleItem',
    props: {
      itemName: String,
      itemKeyName: String,
      dateMove: Boolean,
      contentData: Object,
    },
    data() {
      return {
        selectInfo: baseInfoTemp[this.itemKeyName],
        judgeKeyName: ['customevent', 'page_view', 'launch_info'].indexOf(this.itemKeyName) === -1,
        dateValue: [],
        selectRange: [1, 2],
        selectValue: baseInfoTemp[this.itemKeyName].defaultValue || '',
        selectSymbol: baseInfoTemp[this.itemKeyName].defaultSymbol || '',
        selectNumber: baseInfoTemp[this.itemKeyName].defaultNumber || '',
      };
    },
    created() {
      if (this.contentData) this.setData();
    },
    mounted() {
      bus.$on('on-usergroup-recover', () => {
        if (this.contentData) this.setData();
      });
      if (this.judgeKeyName && !this.contentData) {
        this.setcontentValue();
      }
    },
    computed: {
      contentValue() {
        const number = this.selectSymbol === '$between' ? this.selectRange : this.selectNumber;
        const val = this.dateValue.length === 0 ? {
          [this.selectValue]: {
            [this.itemKeyName]: {
              [this.selectSymbol]: number,
            },
          },
        } : {
          [this.selectValue]: {
            [this.itemKeyName]: {
              [this.selectSymbol]: number,
            },
          },
          timeflag: {
            $between: this.dateValue,
          },
        };
        return val;
      },
    },
    methods: {
      // 编辑状态下，设置默认显示内容
      setData() {
        const data = this.contentData;
        this.selectValue = Object.keys(data)[0].toString();
        this.dateValue = data[this.selectValue].timeflag ?
         data[this.selectValue].timeflag.$between : [];
        this.selectSymbol = Object.keys(data[this.selectValue][this.itemKeyName])[0].toString();
        if (this.selectSymbol === '$between') {
          this.selectRange = data[this.selectValue][this.itemKeyName][this.selectSymbol];
        } else {
          this.selectNumber = data[this.selectValue][this.itemKeyName][this.selectSymbol].toString();
        }
      },
      dateChange(val) {
        this.dateValue = val;
        this.setcontentValue();
      },
      setcontentValue() {
        this.$emit('on-change-item', this.itemKeyName, this.contentValue);
      },
      removeItem() {
        this.$emit('on-remove-item', this.itemKeyName);
      },
    },
  };
</script>
